"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var react_spring_1 = require("react-spring");

var react_use_gesture_1 = require("react-use-gesture");

var arrow_1 = __importDefault(require("./components/arrow/arrow"));

var bullet_1 = __importDefault(require("./components/bullet/bullet"));

var StyledSliderArrows = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\ttop: 50%;\n\tposition: absolute;\n\twidth: 100%;\n\tz-index: 1;\n\tdisplay: flex;\n\tjustify-content: space-between;\n"], ["\n\ttop: 50%;\n\tposition: absolute;\n\twidth: 100%;\n\tz-index: 1;\n\tdisplay: flex;\n\tjustify-content: space-between;\n"])));
var StyledBulletList = styled_components_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\tlist-style-type: none;\n\tpadding: 0;\n\tmargin: 15px 0;\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\tlist-style-type: none;\n\tpadding: 0;\n\tmargin: 15px 0;\n"])));
var StyledBullets = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 100%;\n\tz-index: 1;\n"], ["\n\tposition: absolute;\n\tbottom: 0;\n\twidth: 100%;\n\tz-index: 1;\n"])));
var StyledWrapper = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n"], ["\n\twidth: 100%;\n\theight: 100%;\n"])));
var StyledSlider = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tposition: relative;\n\toverflow: hidden;\n\twidth: 100%;\n\theight: 100%;\n"], ["\n\tposition: relative;\n\toverflow: hidden;\n\twidth: 100%;\n\theight: 100%;\n"])));
var StyledSlide = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\twill-change: transform;\n\tuser-select: none;\n\tpointer-events: none;\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\twill-change: transform;\n\tuser-select: none;\n\tpointer-events: none;\n"])));

var clamp = function clamp(input, lower, upper) {
  return Math.min(Math.max(input, lower), upper);
};

var Slider = function Slider(_a) {
  var _b = _a.activeIndex,
      activeIndex = _b === void 0 ? 0 : _b,
      ArrowComponent = _a.ArrowComponent,
      _c = _a.arrowStyle,
      arrowStyle = _c === void 0 ? {} : _c,
      _d = _a.auto,
      auto = _d === void 0 ? 0 : _d,
      BulletComponent = _a.BulletComponent,
      _e = _a.bulletStyle,
      bulletStyle = _e === void 0 ? {} : _e,
      _f = _a.children,
      children = _f === void 0 ? [] : _f,
      _g = _a.hasArrows,
      hasArrows = _g === void 0 ? false : _g,
      _h = _a.hasBullets,
      hasBullets = _h === void 0 ? false : _h,
      _j = _a.onSlideChange,
      onSlideChange = _j === void 0 ? function () {
    return undefined;
  } : _j,
      _k = _a.setSlideCustom,
      setSlideCustom = _k === void 0 ? undefined : _k;
  var sliderRef = react_1.useRef(null);

  var _l = react_1.useState(0),
      slide = _l[0],
      setSlideOriginal = _l[1];

  var setSlide = setSlideCustom ? function (index) {
    return setSlideOriginal(setSlideCustom(index));
  } : setSlideOriginal;

  var _m = react_1.useState(false),
      isDragging = _m[0],
      setDragging = _m[1]; // Initialize slides with spring


  var _o = react_spring_1.useSprings(children.length, function (index) {
    return {
      offset: index
    };
  }),
      springProps = _o[0],
      setSpringProps = _o[1]; // Bindings to set on the element


  var gestureBinds = react_use_gesture_1.useGesture({
    onDrag: function onDrag(_a) {
      var down = _a.down,
          xDelta = _a.movement[0],
          xDir = _a.direction[0],
          distance = _a.distance,
          cancel = _a.cancel,
          first = _a.first;

      if (first) {
        setDragging(true);
      }

      if (sliderRef && sliderRef.current && sliderRef.current.parentElement) {
        var width_1 = sliderRef.current.parentElement.getBoundingClientRect().width;

        if (down && distance > width_1 / 2) {
          if (cancel) cancel();
          setSlide(clamp(slide + (xDir > 0 ? -1 : 1), 0, children.length - 1));
        } // see:  https://github.com/react-spring/react-spring/issues/861
        // @ts-ignore


        setSpringProps(function (index) {
          return {
            offset: (down ? xDelta : 0) / width_1 + (index - slide)
          };
        });
      }
    },
    onClick: function onClick() {
      if (isDragging) {
        setDragging(false);
        return;
      }

      clickOnSlide(slide);
    }
  }, {
    drag: {
      delay: 200
    }
  }); // Triggered on slide change

  react_1.useEffect(function () {
    // see:  https://github.com/react-spring/react-spring/issues/861
    // @ts-ignore
    setSpringProps(function (index) {
      return {
        offset: index - slide
      };
    });
    onSlideChange(slide);
  }, [slide, setSpringProps, onSlideChange]); // Effect for autosliding

  react_1.useEffect(function () {
    var interval;

    if (auto > 0) {
      interval = setInterval(function () {
        var targetIndex = (slide + 1) % children.length;
        setSlide(targetIndex);
      }, auto);
    }

    return function () {
      if (interval) clearInterval(interval);
    };
  }, [auto, children.length, slide]); // Jump to slide index when prop changes

  react_1.useEffect(function () {
    setSlide(activeIndex % children.length);
  }, [activeIndex, children.length]); // Sets pointer events none to every child and preserves styles

  var childs = children.map(function (child, index) {
    return react_1.default.createElement(StyledSlide, {
      key: index
    }, child) // eslint-disable-line react/no-array-index-key
    ;
  }); // Calls onClick on the current slide

  var clickOnSlide = function clickOnSlide(slideIndex) {
    childs[slideIndex].props.children.props.onClick && childs[slideIndex].props.children.props.onClick();
  };

  var nextSlide = function nextSlide() {
    if (slide === children.length - 1) {
      setSlide(0);
      return;
    }

    setSlide(slide + 1);
  };

  var previousSlide = function previousSlide() {
    if (slide === 0) {
      setSlide(children.length - 1);
      return;
    }

    setSlide(slide - 1);
  };

  return react_1.default.createElement(StyledWrapper, {
    ref: sliderRef
  }, react_1.default.createElement(StyledSlider, null, hasArrows && react_1.default.createElement(StyledSliderArrows, null, react_1.default.createElement(arrow_1.default, {
    ArrowComponent: ArrowComponent,
    arrowStyle: arrowStyle,
    direction: "left",
    onClick: previousSlide
  }), react_1.default.createElement(arrow_1.default, {
    ArrowComponent: ArrowComponent,
    arrowStyle: arrowStyle,
    direction: "right",
    onClick: nextSlide
  })), hasBullets && react_1.default.createElement(StyledBullets, null, react_1.default.createElement(StyledBulletList, null, children.map(function (_, index) {
    return react_1.default.createElement(bullet_1.default, {
      key: index,
      index: index,
      BulletComponent: BulletComponent,
      setSlide: setSlide,
      activeIndex: slide,
      bulletStyle: bulletStyle
    });
  }))), springProps.map(function (_a, index) {
    var offset = _a.offset;
    return react_1.default.createElement(react_spring_1.animated.div, __assign({}, gestureBinds(), {
      key: index,
      className: "slider__slide",
      style: {
        transform: offset.interpolate(function (offsetX) {
          return "translate3d(" + offsetX * 100 + "%, 0, 0)";
        }),
        position: "absolute",
        width: "100%",
        height: "100%",
        willChange: "transform"
      }
    }), childs[index]);
  })));
};

exports.default = Slider;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;